import React, { useEffect, useState } from "react";
import { Card, CardHeader, Collapse } from "reactstrap";
import axios from "axios";
import { routes } from "../gen/General";
import { useSelector } from "react-redux";

export const CltEjecutivos = ({ clt }) => {
    const user = useSelector(state => state.user);
    const [open, setOpen] = useState(false);
    const [ejecutivo, setEjecutivo] = useState([]);

    useEffect(() => {
        getEjecutivo();
    }, []);

    const openCollapse = () => {
        setOpen(!open);
    };
    const getEjecutivo = () => {
        axios
            .get(routes.api + "/datos-eje", {
                params: {
                    cdCliente: user.cdCliente,
                },
            })
            .then(resp => {
                setEjecutivo(resp.data);
            })
            .catch(error => {
                //alert('Error al traer el usuario' + error);
            });
    };

    return (
        <div className="card-collapse">
            <Card className="card-plain my-0">
                <CardHeader role="tab">
                    <div data-toggle="collapse" className="expanded c-pointer" onClick={openCollapse}>
                        {"Ejec. Cuenta Bróker"}&nbsp;&nbsp;
                        <i
                            className={
                                !open ? "now-ui-icons arrows-1_minimal-down" : "now-ui-icons arrows-1_minimal-up"
                            }
                        />
                    </div>
                </CardHeader>
                <Collapse isOpen={open}>
                    <div className={"table-responsive"}>
                        <table className="table table-striped table-hover">
                            <thead className="thead-inverse text-primary">
                                <tr>
                                    <th className="text-left">#</th>
                                    <th className="text-left">Ejecutivo</th>
                                    <th className="text-left">Área</th>
                                    <th className="text-left">Correos</th>
                                    <th className="text-left">Teléfono</th>
                                </tr>
                            </thead>
                            <tbody>
                                {(ejecutivo || []).map((a, index) => (
                                    <tr key={a.cdEjecutivo}>
                                        <td className="text-left">
                                            <span>{index + 1}</span>
                                        </td>
                                        <td className="text-left">
                                            <span>{a.agente}</span>
                                        </td>
                                        <td className="text-left">
                                            <span>{a.area}</span>
                                        </td>
                                        <td className="text-left">
                                            <span>
                                                <a
                                                    href={"mailto:" + a.correos}
                                                    className={"text-decoration-underline mx-1"}
                                                >
                                                    {a.correos}
                                                </a>
                                            </span>
                                        </td>
                                        <td className="text-left">
                                            <span>
                                                <a
                                                    href={"telf:" + a.telefonos}
                                                    className={"text-decoration-underline mx-1"}
                                                >
                                                    {a.telefonos}
                                                </a>
                                            </span>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </Collapse>
            </Card>
        </div>
    );
};
